'use strict';

const {
	section, i, ul, li, a, img
} = require('iblokz-snabbdom-helpers');

const calendar = require('./calendar');
const addressMap = require('../widgets/address-map');
const venueUtil = require('../../util/venue');
const gravatar = require('../../util/gravatar');
const _rl = require('../../util/resolve-localized');
const {resolveLocalized, DEFAULT_LOCALE} = _rl.default || _rl;

const profilePath = profile => {
	if (!profile) return '';
	const id = profile.slug || profile._id;
	return id ? `/profiles/${id}` : '';
};

const isEventDetail = path =>
	(path[0] === 'calendar' || path[0] === 'events') && Boolean(path[1]);

const hydrateVenueProfile = (event, profiles) => {
	const venue = event && event.venue;
	const ref = venue && venue.profile;
	if (!ref || typeof ref === 'object') return event;
	const id = String(ref);
	const found = (profiles || []).find(p =>
		String(p._id) === id || p.slug === id
	);
	if (!found) return event;
	return Object.assign({}, event, {
		venue: Object.assign({}, venue, {profile: found})
	});
};

const eventDetailPane = ({state, i18n}) => {
	const lang = state.lang || DEFAULT_LOCALE;
	const event = hydrateVenueProfile(
		state.events && state.events.doc || {},
		(state.profiles && state.profiles.list) || []
	);
	const title = resolveLocalized(event.title, lang) || '';
	const venue = venueUtil.resolveVenue(event, lang);
	const address = venue && venue.address;
	const showAddress = venueUtil.addressHasContent(address);
	const profile = venue && venue.profile;
	const gravatarUtil = gravatar.default || gravatar;
	const avatar = profile && gravatarUtil.src
		? gravatarUtil.src(profile, 112)
		: (profile && profile.avatar) || '';
	const profileUrl = profilePath(profile);
	const description = profile
		? resolveLocalized(profile.about, lang)
		: '';

	return [
		event.poster
			? section('.poster', [
				img({attrs: {src: event.poster, alt: title}})
			])
			: '',
		showAddress
			? addressMap({
				address,
				title: venue.name || undefined,
				avatar: avatar || undefined,
				url: profileUrl || undefined,
				description: description || undefined,
				lang,
				i18n
			})
			: ''
	];
};

const defaultPane = ({state, actions}) => [
	section([
		ul([
			li([a('[href="https://fb.com/musictech.bg"][target="_blank"]', [
				i('.fa.fa-facebook'),
				'MusicTech.bg @ Facebook'
			])]),
			li([a('[href="https://fb.com/groups/musictechbg"][target="_blank"]', [
				i('.fa.fa-facebook-official'),
				'Facebook Група MusicTechBG'
			])]),
			li([a('[href="https://www.youtube.com/channel/UCphmUQ_1b0g9sIhmo505nAg"][target="_blank"]', [
				i('.fa.fa-youtube'),
				'Youtube Канал MusicTechBG'
			])])
		])
	]),
	calendar({state, actions})
];

module.exports = ({state, actions, i18n}) => {
	const path = (state.router && state.router.path) || [];
	return section('.right-pane',
		isEventDetail(path)
			? eventDetailPane({state, i18n})
			: defaultPane({state, actions})
	);
};
